module.exports = __webpack_public_path__ + "static/media/7.8b82f049.svg";